import { AuthLayout, ForgotPasswordForm } from '../components';
import Homescreen_icon from '../../home/assets/Homescreen.png';
import { AUTH_SUBTITLE_CLASS, AUTH_TITLE_CLASS } from '../lib/authStyles';

export function ForgotPasswordPage() {
  return (
    <AuthLayout rightImage={Homescreen_icon} rightAlt="Aexon Assistant Mockup">
      <h1 className={AUTH_TITLE_CLASS}>Forgot Password</h1>
      <h2 className={AUTH_SUBTITLE_CLASS}>
        Enter your registered email address and we’ll send you a verification
        code to reset your password.
      </h2>

      <div className="animate-fadeIn">
        <ForgotPasswordForm />
      </div>
    </AuthLayout>
  );
}
